// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Button from "../../resources/actions/Button.res.js";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Popover from "../../resources/overlays/Popover.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as OpeningButton from "../../resources/actions/OpeningButton.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as InputNumberField from "../../resources/selection-and-input/InputNumberField.res.js";
import * as ToggleButtonGroup from "../../resources/actions/ToggleButtonGroup.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function PromotionEditDiscountedProductDiscountTableCell(props) {
  let onRequestReplicate = props.onRequestReplicate;
  let onRequestUpdate = props.onRequestUpdate;
  let bulkUnit = props.bulkUnit;
  let discount = props.discount;
  let disabled = props.disabled;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let discountKindRef = React.useRef(discount.kind);
  React.useEffect(() => {
    discountKindRef.current = discount.kind;
  }, [discount.kind]);
  let onDiscountKindChange = React.useCallback(kind => {
    let match = discount.amount > 100;
    onRequestUpdate({
      id: discount.id,
      amount: kind === "PERCENT" && match ? 0 : discount.amount,
      kind: kind
    });
  }, [discount.amount]);
  let onDiscountAmountChange = React.useCallback(amount => {
    let match = discountKindRef.current;
    let match$1 = amount <= 100;
    if (match === "PERCENT" && !match$1) {
      return;
    }
    onRequestUpdate({
      id: discount.id,
      amount: amount,
      kind: discountKindRef.current
    });
  }, []);
  let tmp;
  if (props.editable) {
    let match$1 = discount.kind;
    tmp = JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(OpeningButton.make, {
        children: JsxRuntime.jsx(TextStyle.make, {
          children: match$1 === "PERCENT" ? I18n.percentFormat(undefined, undefined, undefined, discount.amount / 100) : I18n.currencyFormat(undefined, "EUR", undefined, undefined, discount.amount),
          variation: disabled ? "normal" : "neutral"
        }),
        ariaProps: popoverAriaProps.triggerProps,
        opened: popover.isOpen,
        disabled: disabled,
        onPress: param => popover.toggle(),
        ref: popoverTriggerRef
      }),
      spaceTop: "xxsmall"
    });
  } else {
    let match$2 = discount.kind;
    tmp = JsxRuntime.jsx(TextStyle.make, {
      children: match$2 === "PERCENT" ? I18n.percentFormat(undefined, undefined, undefined, discount.amount / 100) : I18n.currencyFormat(undefined, "EUR", undefined, undefined, discount.amount)
    });
  }
  let tmp$1;
  if (popover.isOpen) {
    let match$3 = discount.kind;
    tmp$1 = JsxRuntime.jsx(Popover.make, {
      children: JsxRuntime.jsx(Popover.Dialog.make, {
        children: JsxRuntime.jsxs(Box.make, {
          children: [
            JsxRuntime.jsxs(Inline.make, {
              children: [
                JsxRuntime.jsx(Inline.make, {
                  children: JsxRuntime.jsx(ToggleButtonGroup.make, {
                    label: I18n.t("Discount type"),
                    items: [
                      {
                        key: "percent",
                        value: "PERCENT",
                        icon: "percent"
                      },
                      {
                        key: "currency",
                        value: "CURRENCY",
                        icon: "currency"
                      }
                    ],
                    value: {
                      TAG: "Single",
                      _0: discount.kind
                    },
                    onChange: selection => {
                      if (typeof selection !== "object" || selection.TAG !== "Single") {
                        return;
                      } else {
                        return onDiscountKindChange(selection._0);
                      }
                    }
                  })
                }),
                JsxRuntime.jsx(InputNumberField.make, {
                  value: discount.amount,
                  minValue: 0,
                  maxValue: discount.kind === "PERCENT" ? 100 : undefined,
                  minPrecision: discount.kind === "PERCENT" ? 0 : undefined,
                  label: I18n.t("Discount amount"),
                  appender: match$3 === "PERCENT" ? "Percent" : (
                      bulkUnit !== undefined ? ({
                          TAG: "Custom",
                          _0: `€ / ` + bulkUnit
                        }) : ({
                          TAG: "Currency",
                          _0: "EUR"
                        })
                    ),
                  onChange: onDiscountAmountChange
                })
              ],
              space: "large"
            }),
            JsxRuntime.jsx(Box.make, {
              children: JsxRuntime.jsx(Inline.make, {
                children: JsxRuntime.jsx(Button.make, {
                  label: I18n.t("Apply to all products"),
                  variant: "subtle",
                  disabled: Stdlib_Option.isNone(onRequestReplicate),
                  icon: "plus_small",
                  onPress: () => {
                    if (onRequestReplicate !== undefined) {
                      onRequestReplicate();
                      return popover.close();
                    }
                  }
                }),
                align: "end"
              }),
              spaceTop: "normal"
            })
          ],
          spaceX: "large",
          spaceTop: "xlarge",
          spaceBottom: "medium"
        }),
        ariaProps: popoverAriaProps.overlayProps
      }),
      triggerRef: popoverTriggerRef,
      state: popover,
      placement: "bottom end",
      shouldUpdatePosition: false,
      modal: false
    });
  } else {
    tmp$1 = null;
  }
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      tmp,
      tmp$1
    ]
  });
}

let make = React.memo(PromotionEditDiscountedProductDiscountTableCell, (oldProps, newProps) => {
  if (oldProps.discount === newProps.discount && oldProps.editable === newProps.editable && oldProps.disabled === newProps.disabled && oldProps.bulkUnit === newProps.bulkUnit) {
    return oldProps.onRequestReplicate === newProps.onRequestReplicate;
  } else {
    return false;
  }
});

export {
  make,
}
/* make Not a pure module */
